/* @ngInject */
export default function () {
	// https://stackoverflow.com/a/17648547/7503569
	return (n, len) => {
		let num = parseInt(n, 10);
		len     = parseInt(len, 10);

		if (isNaN(num) || isNaN(len)) {
			return n;
		}

		num = '' + num;

		while (num.length < len) {
			num = '0' + num;
		}

		return num;
	};
};


// WEBPACK FOOTER //
// ./src/js/filters/numberFixedLength.js